import Box from "@/components/Box";
import { ExternalTextLink } from "@/components/Links";
import { CMP_ORDERS_URL, getOrderUrl } from "@/core/urls";
import useCmpRelatedUrl from "@/hooks/organisations/useCmpRelatedUrl";

export default function OrderedBy({ order, cmpContext = true }) {
  const { resolvedUrls } = useCmpRelatedUrl();

  if (order) {
    if (order.orderCopiedFrom) {
      return (
        <Box fontFamily="gilroyMedium" fontSize={18}>
          Original order:{" "}
          <ExternalTextLink
            href={
              cmpContext
                ? `${resolvedUrls[CMP_ORDERS_URL]}?id=${order.orderCopiedFrom.id}`
                : getOrderUrl(order.orderCopiedFrom.id)
            }
          >
            {order.orderCopiedFrom.id}
          </ExternalTextLink>
        </Box>
      );
    } else {
      return (
        <Box fontFamily="gilroyMedium" fontSize={18} data-testid="orderedBy">
          Ordered by: {order.practitionerWhoPlacedOrderFullName}
        </Box>
      );
    }
  }
}
